/**
 * CanvasBadgesContext — gates diagnostic node badges per canvas kind.
 *
 * Motivation-class chips (`cost:data` / `gain:value`) are generation
 * diagnostics: they belong on the GENERATION (strategy) canvas only. The
 * regular onboarding canvas must stay clean (operator feedback 2026-07-27).
 * Default is false so every canvas hides badges unless the host opts in —
 * only the strategy screens canvas (`editorMode="ai"`) provides true.
 */
import { createContext, useContext } from 'react';

export interface CanvasBadgesContextValue {
  showMotivationBadges: boolean;
}

export const CanvasBadgesContext = createContext<CanvasBadgesContextValue>({
  showMotivationBadges: false,
});

export const useCanvasBadges = () => useContext(CanvasBadgesContext);
